import { apiSlice } from "./apiSlice";

export const approvedUsersApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getApprovedUsers: builder.query({
            query: () => 'public/duc/approved-users',
            providesTags: () => [{ type: "ApprovedUsers" }],
        }),
    })
});

export const { useGetApprovedUsersQuery } = approvedUsersApiSlice;
